export const stats = [
  { value: '+600', label: 'Sequenze e Schede Pronte' },
  { value: '+1.500', label: 'Insegnanti Soddisfatti' },
  { value: '4.200+', label: 'Ore di Pianificazione Risparmiate' },
  { value: '98%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+600', label: 'Sequenze e Schede (dalle Fondamenta alla Maestria)' },
  { value: '6', label: 'Volumi Digitali Completi' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a pianificare ogni singola lezione da zero cercando su siti e social diversi',
  "Ansia da spiegazione: non sapere come spiegare un concetto complesso o un allineamento in modo semplice",
  "Nessuna connessione chiara tra la pratica fisica e la filosofia o l'anatomia",
  'Difficoltà nel creare varianti per diversi livelli o allievi con limitazioni',
]

export const afterItems = [
  '5 minuti di revisione e sei pronta per entrare in classe con sicurezza',
  'Sequenze fluide e coinvolgenti con grafiche ad alta risoluzione integrate',
  'Quiz, verifiche e rubriche già pronti al 100% per monitorare i progressi',
  'Studenti che capiscono davvero grazie a infografiche e mappe concettuali',
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Volumi basati sull\u2019Anno Scolastico',
    text: 'Dalla scoperta dei sensi alle inversioni e maestria avanzata',
  },
  {
    emoji: '🧘‍♀️',
    title: 'Script delle Lezioni «Pronti al Volo»',
    text: 'Suggerimenti didattici che ti dicono esattamente cosa dire durante la lezione',
  },
  {
    emoji: '📐',
    title: 'Yoga Visuale: Infografiche e Mappe',
    text: 'Grafiche 8K che rendono comprensibili i processi invisibili: atomi, energia, anatomia',
  },
  {
    emoji: '📊',
    title: 'Verifiche, Soluzioni e Supporto BES/DSA',
    text: 'Strumenti per una didattica davvero inclusiva per tutti i tipi di allievi',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Chiavi di Correzione)',
    text: 'Soluzioni complete per correzioni istantanee e senza stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5h6H4SeFAHpsi8HP7PUV2x/Captura_de_pantalla_2026-09-06_a_las_9.43.45_p.webp',
    level: 'Fondamenta · Sequenza',
    title: 'Sequenza completa in flusso',
    caption:
      'I nove passaggi del saluto al sole con respiro indicato passo per passo e una nota su come insegnare il flusso senza affrettare le transizioni.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3yzw5Xt93bRJG69hQi3DPP/Captura_de_pantalla_2026-09-06_a_las_9.44.56_p.webp',
    level: 'Unità 2 · Settimane 3-4',
    title: 'Vinyasa intermedio: transizioni dinamiche',
    caption:
      'Nove asana con intenzione e beneficio di ciascuna, i due nuovi elementi evidenziati e il ciclo completo di ritorno a Tadasana.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aiS6oZXAuyS415iUVKBJJg/Captura_de_pantalla_2026-09-06_a_las_9.45.58_p.webp',
    level: 'Maestria · Tracker',
    title: 'Mappa di progressione arm balances (6 settimane)',
    caption:
      'Tabella da compilare settimana per settimana con scala di valutazione da «non pronto» a «maestria» per quattro equilibri sulle braccia.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ovveFqdEnWCqWGazjHVUoF/Captura_de_pantalla_2026-09-06_a_las_9.47.07_p.webp',
    level: 'Sicurezza · Scheda tecnica',
    title: 'Tecniche di aggiustamento sicuro',
    caption:
      'Tre aggiustamenti manuali spiegati con posizione delle mani, comunicazione verbale e i limiti da non superare mai.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4WTo6wUVHQP777a8Lxgu9Q/Captura_de_pantalla_2026-09-06_a_las_9.52.19_p.webp',
    level: 'Inclusività · Varianti',
    title: 'Usa la posa per entrare nel corpo',
    caption:
      'Quattro varianti della Pigeon Pose secondo la struttura dell\u2019anca e le limitazioni articolari, con supporti e alternative supine.',
  },
]

export const bonuses = [
  {
    title: 'KIT PRONTO CLASSE PERFETTA™',
    was: '€15',
    text: 'Il sistema rapido per insegnanti di yoga organizzati: la formula per strutturare ogni lezione e template pronti all\u2019uso',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0523a1d7-ce46-4aca-9bb6-85db15af52bf.jpg',
  },
  {
    title: '50 Script di Voce per Insegnanti di Yoga',
    was: '€10',
    text: "L'arte della guida verbale: tono, ritmo e presenza, con script per accoglienza, centratura, Pranayama e transizioni",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/2c49bdb7-5981-4b0a-9793-28ef7b357774.jpg',
  },
  {
    title: 'Checklist Sicurezza Asana',
    was: '€8',
    text: 'Insegnare con precisione e fiducia: i «red flags» da monitorare in sala e checklist per colonna, ginocchia e spalle',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/dc856ced-6940-4998-8d79-d1d681091634.jpg',
  },
  {
    title: 'Planner Mensile Lezioni Yoga',
    was: '€10',
    text: 'Trasforma la tua visione in un calendario reale: temi mensili coerenti e tracker per feedback e presenze',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3f33fb60-e189-40b7-8666-d3544032f203.jpg',
  },
  {
    title: 'Mini Guida Studenti Felici',
    was: '€9',
    text: "Oltre la sequenza: la psicologia della connessione per far sì che i tuoi allievi tornino lezione dopo lezione",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0b215c44-e5f3-4e65-a657-682bcd94c62a.jpg',
  },
]

export const offerRows = [
  { label: 'YOGA PRONTA™ Pack (6 Volumi Digitali)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€52' },
]

export const testimonials = [
  {
    quote:
      'Ho finalmente recuperato le mie serate. I miei allievi adorano le nuove schede visive.',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      "Materiale professionale e pronto all'uso. Gli script di voce mi hanno dato una sicurezza incredibile.",
    name: 'Luca B.',
    location: 'Roma 🇮🇹',
  },
  {
    quote:
      "Dalle basi alle lezioni avanzate, è l'unico investimento che serve a un'insegnante di yoga.",
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: "Tramite download digitale immediato dopo l'acquisto.",
  },
  {
    q: 'Funziona per tutti i livelli?',
    a: 'Sì, dai principianti assoluti ai praticanti esperti.',
  },
  {
    q: 'È adatto per allievi con necessità speciali?',
    a: 'Sì, include guide per adattamenti e inclusività.',
  },
  {
    q: 'Ci sono costi mensili?',
    a: 'Assolutamente no. Il pagamento è unico.',
  },
]
